import React, {useEffect, useState} from "react";
import Axios from "axios";
import {mainUrl} from "../../api/axios";
import {Button, Col, Form, FormGroup, Modal, Row, Table,Spinner} from "react-bootstrap";
import {CardBody, CardHeader, CardTitle, Input} from "reactstrap";
import toast, {Toaster} from "react-hot-toast";

export default function Location(headers) {
    const [showModal, setShowModal] = React.useState(false);
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    const [recordId, setRecordId] = React.useState(0);
    const [province, setProvince] = React.useState([]);
    const [list, setList] = React.useState([]);

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        fetchProvince();
        fetchList();
    }, []);
    const fetchProvince = async () => {
        const {data} = await Axios.get(mainUrl + "getProvince", headers);
        const lists = data;
        setProvince(lists);
    };
    const fetchList = async () => {
        const {data} = await Axios.get(mainUrl + "getLocation", headers);
        const lists = data;
        setList(lists);
        setIsLoading(true);
    };
    const addLocation = async (e) => {
        e.preventDefault();
        await Axios.post(mainUrl + "addLocation", {
            id: e.target.id.value,
            province_id: e.target.province_id.value,
            name: e.target.name.value
        }, headers).then(res => {
            if (e.target.id.value == 0) {
                notifySuccess(' Added Successfully.');
            } else {
                notifySuccess(' Updated Successfully.');
            }
            setList(res.data);
            setShowModal(false);
        }).catch(function (error) {
            notifyError(error.response.data.message);
            setShowModal(false);
        });
    };
    const onDeleteRecord = async (e) => {
        e.preventDefault();
        await Axios.post(mainUrl + "deleteLocation", {
            id: recordId
        }, headers).then(res => {
            notifySuccess("Successfully deleted");
            const lists = res.data;
            setList(lists);
        }).catch((error) => {
            notifyError(error.response.data.message);

        });
        setRecordId(0);
        setShowDeleteModal(false);
    }

    const notifyError = (message) => toast.error(message, {
        duration: 6000,
    });
    const notifySuccess = (message) => toast.success(message, {
        duration: 6000,
    });
    return (
        <>

            <div className="content">
                {isLoading===false?(
                    <div className="text-center">
                        <Spinner  animation="border" variant="info" />
                    </div>
                ):(
                    <div>
                        <AddItem/>
                        <TableData/>
                        <DeleteItem/>
                    </div>
                    )}
            </div>
        </>
    );

    function DeleteItem() {
        return (
            <>
                <Modal show={showDeleteModal} backdrop="static" size="lg" onHide={() => setShowDeleteModal(false)}>
                    <form onSubmit={(e) => onDeleteRecord(e)}>
                        <Modal.Header>
                            <div className="modal-profile">
                                <h2>Confirmation</h2>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="pr-3">
                                <Col md="12">
                                    Are you sure you want to delete?
                                </Col>
                            </Row>
                        </Modal.Body>
                        <div className="modal-footer">
                            <Button title="Close"
                                    className="btn-simple"
                                    type="button"
                                    variant="link"
                                    onClick={() => setShowDeleteModal(false)}>
                                Close
                            </Button>
                            <Button title="Yes , I am sure" className="btn-round" color="danger" type="submit">
                                Yes
                            </Button>
                        </div>
                    </form>
                </Modal>
            </>
        );
    }

    function AddItem() {
        return (
            <>
                <Modal show={showModal} backdrop="static" size="xl" onHide={() => setShowModal(false)}>
                    <Form onSubmit={(e) => addLocation(e)}>
                        <Modal.Header className="justify-content-center">
                            <div className="modal-profile">
                                New Location
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="pr-3">
                                <Input hidden={true} required name="id" id="id" value="0" type="hidden"/>
                                <Col md="6">
                                    <FormGroup>
                                        <label>Province</label>
                                        <select id="province_id" required
                                                className="form-control">
                                            {province.map((province) => (
                                                <option key={province.id}
                                                        value={province.id}>{province.name}</option>
                                            ))}
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col className="pr-3" md="6">
                                    <FormGroup>
                                        <label>Location name <span className="text text-danger">*</span></label>
                                        <Input required name="name" id="name"
                                               placeholder="Location name" title="Location name" type="text"/>
                                    </FormGroup>
                                </Col>

                            </Row>

                        </Modal.Body>
                        <div className="modal-footer">
                            <Button title="Close"
                                    className="btn-simple"
                                    type="button"
                                    variant="link"
                                    onClick={() => setShowModal(false)}>
                                Close
                            </Button>
                            <Button title="Insert & update  Record" className="btn-round" color="danger" type="submit">
                                Add
                            </Button>
                        </div>
                    </Form>
                </Modal>
            </>
        );
    }

    function TableData() {
        let no = 1;
        return (
            <>
                <Row>
                    <Col md="12">
                        <div className="card-user">
                            <CardHeader>
                                <CardTitle className="mr-4 ml-4">
                                    <div className="row">
                                        <div className="ml-right">
                                            <h2> Location List </h2>
                                        </div>
                                        <div className="ml-end">
                                            <Button title="Add New Record" className="btn-success" variant="primary"
                                                    onClick={() => {
                                                        setRecordId(0);
                                                        setShowModal(true)
                                                    }}>
                                                <span className="nc-icon nc-simple-add"/>
                                            </Button>
                                        </div>
                                    </div>
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Table>
                                    <thead className="text-primary">
                                    <tr>
                                        <th>No</th>
                                        <th>Province</th>
                                        <th>Location Name</th>
                                        <th className="text-right">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {list.map((e) => (

                                        <tr key={e.id}>

                                            <td>{no++}</td>
                                            <td style={{width: "50%"}}>{e.province_name}</td>
                                            <td style={{width: "50%"}}>{e.location_name}</td>

                                            <td style={{whiteSpace: "nowrap"}} className="text-right">
                                                <Button title="Delete Record" onClick={() => {
                                                    setRecordId(e.id);
                                                    setShowDeleteModal(true);
                                                }} className="btn-round  btn-danger"
                                                        color="danger" type="Button">
                                                    <span className="nc-icon nc-simple-delete"/>
                                                </Button>&nbsp;&nbsp;
                                                <Button title="Update & Detail View Record" onClick={async () => {
                                                    await setShowModal(true);
                                                    document.getElementById('name').value = e.location_name;
                                                    document.getElementById('province_id').value = e.province_id;
                                                    document.getElementById('id').value = e.id;

                                                }} className="btn-round" color="success" type="Button">
                                                    <span className="nc-icon nc-sound-wave"/>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}